<template>
  <div class="mt-0 mb-5">
    <v-row>
      <v-col cols="12">
        <label style="font-weight: bold">{{
          $t("Panier.SectionAdresseEleve.TitreSectionAdresse")
        }}</label></v-col>
    </v-row>

    <v-row>
      <!-- No -->
      <v-col
        cols="3"
        md="1"
        class="py-1 pr-1"
      >
        <v-text-field
          dense
          v-model="adresseEleve.numeroMunicipal"
          :rules="rules.noTexte"
          v-on:input="emettre"
          :label="$t('Panier.SectionAdresseEleve.Numero')"
          outlined
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <!-- Rue -->
      <v-col
        cols="6"
        md="4"
        class="py-1 pr-1"
      >
        <v-text-field
          dense
          v-model="adresseEleve.rue"
          :rules="rules.texte"
          v-on:input="emettre"
          :label="$t('Panier.SectionAdresseEleve.Rue')"
          outlined
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <!-- App -->
      <v-col
        cols="3"
        md="1"
        class="py-1 pr-1"
      >
        <v-text-field
          dense
          v-model="adresseEleve.appartement"
          v-on:input="emettre"
          :label="$t('Panier.SectionAdresseEleve.Appartement')"
          outlined
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <!-- Ville -->
      <v-col
        cols="6"
        md="4"
        class="py-1 pr-1"
      >
        <v-text-field
          dense
          v-model="adresseEleve.ville"
          :rules="rules.texte"
          v-on:input="emettre"
          :label="$t('Panier.SectionAdresseEleve.Ville')"
          outlined
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <!-- Province -->
      <v-col
        cols="6"
        md="2"
        class="py-1 pr-1"
      >
        <v-text-field
          dense
          v-model="adresseEleve.province"
          :placeholder="$t('Panier.SectionAdresseEleve.provincePlaceholder')"
          :rules="rules.texte"
          v-mask="'AA'"
          v-on:input="emettre"
          :label="$t('Panier.SectionAdresseEleve.Province')"
          outlined
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <!-- CodePostal -->
      <v-col
        cols="6"
        md="4"
        class="py-1 pr-1"
      >
        <v-text-field
          dense
          v-model="adresseEleve.codePostal"
          :placeholder="$t('Panier.SectionAdresseEleve.CodePostalPlaceholder')"
          :rules="rules.texte"
          v-mask="'A#A #A#'"
          v-on:input="emettre"
          :label="$t('Panier.SectionAdresseEleve.CodePostal')"
          outlined
          hide-details="auto"
        >
        </v-text-field>
      </v-col>

      <!-- Addresse de -->
      <v-col
        cols="6"
        md="4"
        class="py-1 pr-1"
      >
        <v-select
          dense
          :items="itemsAdresseDeSelect"
          item-value="valeur"
          item-text="nom"
          :rules="rules.select"
          outlined
          hide-details="auto"
          v-on:input="emettre"
          v-model="adresseEleve.adresseDe"
          :label="$t('Panier.SectionAdresseEleve.AdresseDe')"
        >
        </v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AdresseDe } from '../../outils/Enum';

export default {
  name: 'AdressePrincipale',
  props: {
    value: Object,
  },
  data() {
    return {
      rules: {
        texte: [(val) => (val?.trim() || '').length > 0 || this.$t('erreurs.requis')],
        noTexte: [(val) => (val?.trim() || '').length > 0 || this.$t('erreurs.NoRequis')],
        select: [(v) => v != null || this.$t('erreurs.requis')],
      },
      itemsAdresseDeSelect: [
        {
          nom: this.$t('Panier.SectionAdresseEleve.PereMere'),
          valeur: AdresseDe.PereMere,
        },
        {
          nom: this.$t('Panier.SectionAdresseEleve.Pere'),
          valeur: AdresseDe.Pere,
        },
        {
          nom: this.$t('Panier.SectionAdresseEleve.Mere'),
          valeur: AdresseDe.Mere,
        },
        {
          nom: this.$t('Panier.SectionAdresseEleve.Tuteur'),
          valeur: AdresseDe.Tuteur,
        },
      ],

      adresseEleve: Object,
    };
  },
  methods: {
    emettre() {
      this.$emit('input', this.mesuresAide);
    },
  },
  created() {
    this.adresseEleve = this.value;
  },
};
</script>
